import { type DressingWeight } from '@sg/graphql-schema';

export type Event =
  | { type: 'initialize' }
  | { type: 'customization.start' }
  | { type: 'customization.cancel' }
  | { type: 'customization.continue' }
  | { type: 'customization.end' }
  | { type: 'customization.add-modification'; ingredientId: string }
  | { type: 'customization.remove-modification'; ingredientId: string }
  | { type: 'customization.remove-modification-completely'; ingredientId: string } // prettier-ignore
  | { type: 'customization.toggle-bread-modification' }
  | { type: 'customization.dressing-mode.generate-mixed-dressings-details' }
  | { type: 'customization.dressing-mode.toggle' }
  | { type: 'customization.dressing-mode.on-the-side' }
  | { type: 'customization.dressing-mode.mixed-in' }
  | { type: 'customization.dressing.increase-portions'; ingredientId: string }
  | { type: 'customization.dressing.decrease-portions'; ingredientId: string }
  | { type: 'customization.dressing.increase-weight'; ingredientId: string }
  | { type: 'customization.dressing.decrease-weight'; ingredientId: string }
  | { type: 'customization.dressing.change-portions'; ingredientId: string; portions: number } // prettier-ignore
  | { type: 'customization.dressing.change-weight'; ingredientId: string; weight: DressingWeight } // prettier-ignore
  | { type: 'customization.set-custom-name'; customName: string };
